module.exports = __webpack_public_path__ + "img/list4.b937981c.png";